import React from 'react';
import { BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import { UserProvider } from './componentes/UserContext';
import Home from './componentes/Home/index.jsx';
import Venda from './componentes/Venda/index.jsx';
import Footer from './componentes/Footer/index.jsx';
import Contabilidade from './componentes/Contabilidade/index.jsx';

const App = () => {
  return (
    <UserProvider>
      <Router>
        <div>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/venda" element={<Venda />} />
            <Route path='/contabilidade' element={<Contabilidade />} />
          </Routes>
          {/* Rodapé global */}
          <Footer />
        </div>
      </Router>
    </UserProvider>
  );
};

export default App;